// 날짜별로 히스토리 데이터를 그룹핑하는 함수
function groupByDate(history) {
  const now = new Date();
  const today = now.toISOString().slice(0, 10);
  const yesterday = new Date(now.getTime() - 86400000).toISOString().slice(0, 10);
  const weekAgo = new Date(now.getTime() - 7 * 86400000);
  const monthAgo = new Date(now.getTime() - 30 * 86400000);
  const groups = {
    '오늘': [],
    '어제': [],
    '지난 7일': [],
    '지난 30일': [],
    '이전': {}
  };
  history.forEach(item => {
    let itemDate;
    if (item.createdAt && typeof item.createdAt === 'object' && typeof item.createdAt.toDate === 'function') {
      itemDate = item.createdAt.toDate();
    } else if (typeof item.createdAt === 'string') {
      itemDate = new Date(item.createdAt);
    } else {
      itemDate = new Date(0);
    }
    const dateStr = itemDate.toISOString().slice(0, 10);

    // 날짜가 유효하지 않으면 '알 수 없음' 그룹에 넣기
    if (isNaN(itemDate.getTime())) {
      if (!groups['이전']['알 수 없음']) groups['이전']['알 수 없음'] = [];
      groups['이전']['알 수 없음'].push(item);
      return;
    }

    if (dateStr === today) {
      groups['오늘'].push(item);
    } else if (dateStr === yesterday) {
      groups['어제'].push(item);
    } else if (itemDate > weekAgo) {
      groups['지난 7일'].push(item);
    } else if (itemDate > monthAgo) {
      groups['지난 30일'].push(item);
    } else {
      const month = itemDate.getMonth() + 1;
      const year = itemDate.getFullYear();
      const key = `${year}년 ${month}월`;
      if (!groups['이전'][key]) groups['이전'][key] = [];
      groups['이전'][key].push(item);
    }
  });
  return groups;
}

export { groupByDate }; 